var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWaiverDownload = function SvgWaiverDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 13.5996C2.3999 13.1578 2.75807 12.7996 3.1999 12.7996H12.7999C13.2417 12.7996 13.5999 13.1578 13.5999 13.5996C13.5999 14.0414 13.2417 14.3996 12.7999 14.3996H3.1999C2.75807 14.3996 2.3999 14.0414 2.3999 13.5996ZM5.03422 7.43392C5.34664 7.1215 5.85317 7.1215 6.16559 7.43392L7.1999 8.46824L7.1999 2.39961C7.1999 1.95778 7.55807 1.59961 7.9999 1.59961C8.44173 1.59961 8.7999 1.95778 8.7999 2.39961V8.46824L9.83422 7.43392C10.1466 7.1215 10.6532 7.1215 10.9656 7.43392C11.278 7.74634 11.278 8.25287 10.9656 8.56529L8.56559 10.9653C8.41556 11.1153 8.21208 11.1996 7.9999 11.1996C7.78773 11.1996 7.58425 11.1153 7.43422 10.9653L5.03422 8.56529C4.7218 8.25288 4.7218 7.74634 5.03422 7.43392Z",
    fill: "#6B7280"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaiverDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waiver-download.2ca4e061.svg";
export { ForwardRef as ReactComponent };